import { Component } from '@angular/core';
import { membersuiteRevenueRecognitionScheduleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Revenue Recognition Schedules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiterevenuerecognitionschedule-form',
    templateUrl: './membersuiterevenuerecognitionschedule.form.component.html'
})
export class membersuiteRevenueRecognitionScheduleFormComponent extends BaseFormComponent {
    public record!: membersuiteRevenueRecognitionScheduleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

